import { FunctionComponent, PropsWithChildren } from 'react';
import { SwitchCaseProps } from './SwitchCaseProps';

export const SwitchCase: FunctionComponent<PropsWithChildren<SwitchCaseProps>> = ({ children }) => {
  return <>{children}</>;
};
